import { ai2htmlResize } from './utils/ai2html-resizer';

ai2htmlResize('#g-beeswarm-box');
